import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  padding: 1rem;
  gap: 1rem;
`

export const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: .5rem;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;

  & input {
    height: 1rem !important;
  }
`
